export const cbvSupportedBackendTypes = [
  'bit',
  'date',
  'int',
  'float',
  'string',
  // TitleCase shows up in POF/COF-like tables..
  'String'
] as const

type CBVSupportedBackendType = (typeof cbvSupportedBackendTypes)[number]

export type CBVSimplifiedType = 'string' | 'number' | 'boolean' | 'date'

/**
 * Convert more strictly backend type to simpler JS types
 */
export const getSimplifiedType = (
  type: CBVSupportedBackendType
): CBVSimplifiedType => {
  let res: CBVSimplifiedType

  switch (type) {
    case 'bit':
      res = 'boolean'

      break

    case 'date':
      res = 'date'

      break
    case 'float':
    case 'int':
      res = 'number'

      break
    case 'string':
    case 'String':
      res = 'string'
  }

  return res
}
